import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uuidv4 from 'uuid/v4';
import axios from 'axios';
import { updateVars } from 'appSrc/redux/actions';
import style from './styles/style.module.css';


const MATCH_URL = /^https?:\/\/(www\.)?instagram\.com.*\/(tv|p)\/.+$/;
const PLAYER_ID_PREFIX = 'igtv-player-';

class IGTVPlayer extends Component {
    playerName = 'IGTV'
    constructor( props ) {
        super( props );

        this.state = {
            embedHtml: '',
        };

        this.id = PLAYER_ID_PREFIX + uuidv4();
        this.player = {};
        this.title = '';
        this.author_name = '';
        this.author_url = '';
        this.author_id = '';
        this.media_id = '';
        this.provider_name = '';
        this.provider_url = '';
    }
    componentDidMount() {
        // hit insta API for embed content
        axios( {
            url: 'https://api.instagram.com/oembed',
            method: 'get',
            params: {
                url: this.props.url,
                omitscript: true,
                hidecaption: true,
            },
        } )
        .then( ( response ) => {
            var data = response.data;

            this.title = data.title;
            this.author_name = data.author_name;
            this.author_url = data.author_url;
            this.author_id = data.author_id;
            this.media_id = data.media_id;
            this.provider_name = data.provider_name;
            this.provider_url = data.provider_url;

            this.setState( { embedHtml: data.html } );
        } );
    }
    componentDidUpdate( prevProps, prevState ) {
        if( this.props.videoPlaying !== this.id ) {
            this.player && this.player.pauseVideo && this.player.pauseVideo();
        }
        if( this.state.embedHtml !== prevState.embedHtml ) {
            this.activatePlayer();
        }
    }
    activatePlayer = () => {
        // wait for `instgrm` variable to be active
        var i = 0;
        var intervalID = window.setInterval( () => {
            if( window.instgrm && window.instgrm.Embeds ) {
                window.clearInterval( intervalID );
                window.instgrm.Embeds.process();
                this.props.dispatch( updateVars( { videoPlaying: this.id } ) );
            }else if( i > 99 ) {
                window.clearInterval( intervalID );
                console.warn( 'DL: Unable to load IGTV Embed SDK' );
            }
            i++;
        }, 250 );
    }



    render() {
        const { embedHtml } = this.state;

        return (
            <div id={ this.id + '-wrapper' }
            className={ style.videoPlayer }
            style={ this.props.style }
            dangerouslySetInnerHTML={ { __html: embedHtml } } ></div>
        );
    }
}
IGTVPlayer.propTypes = {
    url: PropTypes.string.isRequired,
};
IGTVPlayer.defaultProps = {
    onLoaded: () => {},
    onPlay: () => {},
    onPause: () => {},
    onEnded: () => {},
    onBuffer: () => {},
    onBufferEnd: () => {},
    onError: () => {},
    onReady: () => {},
    muted: false,
};
IGTVPlayer.playerName = 'IGTV';
IGTVPlayer.canPlay = ( url ) => {
    return MATCH_URL.test( url );
};

const mapStateToProps = ( state ) => {
    return {
        videoPlaying: state.vars.videoPlaying,
    };
};

export default connect( mapStateToProps )( IGTVPlayer );
